<div class="main_container mx-4 shadow rounded">

    <!-- BUTTONS SECTION STARTS -->
    <div class="row pt-3 px-3">
        <div class="col-8">
            <div class="d-grid gap-4 d-flex justify-content-start">
                <div class="d-block" style="margin-top: -10px !important;">
                    <h5 class="m-0 p-0">Drivers</h5>
                    <small class="text-secondary">List of all drivers</small>
                </div>

                <div>
                    <div class="input-group">
                        <input type="text" class="form-control" placeholder="Search a Driver"
                            (input)="ClearSearchInput(driverCatalogReq.DriverName)" (keydown.enter)="ListDrivers()"
                            [(ngModel)]="driverCatalogReq.DriverName">
                        <span (click)="ListDrivers()" class="input-group-text pointer">
                            <i class="fi fi-rr-search"></i>
                        </span>
                    </div>
                </div>

                <div>
                    <select class="form-select" [(ngModel)]="driverCatalogReq.StateID" (ngModelChange)="ListDrivers()">
                        <option value="*" selected>-- All States --</option>
                        @for (x of USAStates; track $index) {
                        <option [value]="x.id">{{ x.descr }}</option>
                        }
                    </select>
                </div>

                <div>
                    <select class="form-select" [(ngModel)]="driverCatalogReq.IsActive" (ngModelChange)="ListDrivers()">
                        <option [value]="true">Active</option>
                        <option [value]="false">Inactive</option>
                    </select>
                </div>

            </div>
        </div>

        <div class="col-4">
            <div class="d-grid gap-3 d-md-flex justify-content-end">
                <button (click)="InitDriver()" class="btn btn-primary">
                    <i class="me-1 fi fi-ss-layer-plus"></i>
                    Add Driver
                </button>
                <button class="btn btn-outline-primary" data-bs-toggle="modal" data-bs-target="#makeAppointment">
                    <i class="me-1 fi fi-ss-file-export"></i>
                    Export Data
                </button>
            </div>
        </div>
    </div>
    <!-- BUTTONS SECTION ENDS -->

    <!-- DRIVER TABLE STARTS -->
    <div class="table_container mt-4" infinite-scroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="500"
        (scrolled)="OnScrollCustomerList()" [scrollWindow]="false">
        @if (drivers.length > 0) {
        <table class="table _animated _fadeIn">
            <thead>
                <tr class="ps-3 text-center">
                    <th>Id</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>QB Account</th>
                    <th>State</th>
                    <th>City</th>
                    <th>Insurance Exp. Date</th>
                    <th>Licence Exp. Date</th>
                    <th>medical Card Exp. Date</th>
                    <th>Vehicle Reg. Exp. Date</th>
                    <th>Vehicle Insp. (90 days) Exp. Date</th>
                    <th style="z-index: 999 !important;">Active</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                @for (x of drivers; track $index) {
                <tr (dblclick)="x.readOnly ? NavigateToDriverDetail(x.DriverID) : ''" class="ps-3">
                    <td>
                        <input readonly class="form-control" type="number" [(ngModel)]="x.DriverID">
                    </td>
                    <td>
                        <input [readOnly]="x.readOnly" class="form-control" type="text" [(ngModel)]="x.FirstName">
                    </td>
                    <td>
                        <input [readOnly]="x.readOnly" class="form-control" type="text" [(ngModel)]="x.LastName">
                    </td>
                    <td>
                        <input [readOnly]="x.readOnly" class="form-control" type="text" [(ngModel)]="x.email">
                    </td>
                    <td>
                        <input [readOnly]="x.readOnly" class="form-control" type="text"
                            [(ngModel)]="x.QuickBooksAccountCode" placeholder="QB account code"
                            title="QuickBooks account code for driver pay journal">
                    </td>
                    <td>
                        @if (x.readOnly) {
                        <input readonly type="text" class="form-control" [value]="x.state">
                        }
                        @else {
                        <app-state-search [idx]="$index" [readMode]="x.readOnly"
                            [defaultValue]="(x.stateID != null ? x?.stateID + '. ' + x?.state : '')"
                            (searchEvent)="SetStateId($index, $event)">
                        </app-state-search>
                        }
                    </td>
                    <td>
                        @if (x.readOnly) {
                        <input readonly type="text" class="form-control" [value]="x.city">
                        }
                        @else {
                        <app-city-search [idx]="$index" [readMode]="x.readOnly"
                            [defaultValue]="(x.CityID != null ? x?.CityID + '. ' + x?.city : '')"
                            (searchEvent)="SetCityId($index, $event)">
                        </app-city-search>
                        }
                    </td>
                    <td>
                        <input [readOnly]="x.readOnly" class="form-control" type="date"
                            [(ngModel)]="x.insuranceExpDate">
                    </td>
                    <td>
                        <input [readOnly]="x.readOnly" class="form-control" type="date"
                            [(ngModel)]="x.DriverLicenseExpDate">
                    </td>
                    <td>
                        <input [readOnly]="x.readOnly" class="form-control" type="date"
                            [(ngModel)]="x.MedicalCardExpDate">
                    </td>
                    <td>
                        <input [readOnly]="x.readOnly" class="form-control" type="date"
                            [(ngModel)]="x.VehicleRegistrationExpDate">
                    </td>
                    <td>
                        <input [readOnly]="x.readOnly" class="form-control" type="date"
                            [(ngModel)]="x.VehicleInspection90DayExpDate">
                    </td>
                    <td class="text-center">
                        <input type="checkbox" class="form-check-input" [(ngModel)]="x.Active"
                            (ngModelChange)="OpenSetDriverStatusModal($index)"
                            style="font-size: 14px !important; border: 1px solid gray;">
                    </td>

                    <td class="pt-1 pe-2">
                        <div class="d-grid d-flex gap-2 justify-content-center">

                            @if (!x.readOnly) {
                            <span (click)="PatchDriver(x, $index)">
                                <i class="fi fi-rr-disk"></i>
                            </span>
                            }
                            @else {
                            <span (click)="SetEditMode($index)">
                                <i class="fi fi-rr-pencil"></i>
                            </span>
                            }

                            <span (click)="OpenRemoveDriverModal($index)">
                                <i class="fi fi-rr-trash-xmark"></i>
                            </span>

                        </div>
                    </td>
                </tr>
                }
            </tbody>
        </table>
        }
    </div>
    <!-- DRIVER TABLE ENDS -->


    <!-------------------------- MODALS SECTION --------------------------->

    <!-- DELETE DRIVER MODAL STARTS -->
    <div class="modal modal-lg fade" id="deleteDriver" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="width: 400px !important;">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5">&nbsp;</h1>
                    <a type="button" data-bs-dismiss="modal">
                        <i class="h5 fi fi-rr-circle-xmark"></i>
                    </a>
                </div>
                <div class="modal-body">

                    <p>
                        The driver
                        <span class="text-primary fs-6">
                            {{ this.drivers[selectedIdx]?.FirstName }} {{ this.drivers[selectedIdx]?.LastName }}
                        </span>
                        will be permanently deleted.
                    </p>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-primary" data-bs-dismiss="modal">
                        Cancel
                    </button>
                    <button (click)="RemoveDriver()" type="button" class="btn btn-primary">
                        Delete
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- DELETE DRIVER MODAL ENDS -->

    <!-- SET DRIVER STATUS MODAL STARTS -->
    <div class="modal modal-lg fade" id="setDriverStatus" data-bs-backdrop="static" data-bs-keyboard="false"
        tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="width: 400px !important;">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5">&nbsp;</h1>
                    <a type="button" data-bs-dismiss="modal">
                        <i class="h5 fi fi-rr-circle-xmark"></i>
                    </a>
                </div>
                <div class="modal-body">

                    <p>
                        The driver
                        <span class="text-primary fs-6">
                            {{ this.drivers[selectedIdx]?.FirstName }} {{ this.drivers[selectedIdx]?.LastName }}
                        </span>
                        will be set to
                        <span class="text-primary fs-6">
                            "{{ this.drivers[selectedIdx]?.Active ? 'Active' : 'Inactive' }}"
                        </span>
                    </p>

                </div>
                <div class="modal-footer">
                    <button (click)="CloseAndRevertStatus()" type="button" class="btn btn-outline-primary"
                        data-bs-dismiss="modal">
                        Cancel
                    </button>
                    <button (click)="SetStatus()" type="button" class="btn btn-primary">
                        Save
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- SET DRIVER STATUS MODAL ENDS -->


    <app-custom-toast></app-custom-toast>

</div>
